<section class="vm-row vm-links-group" [id]="data?.id">
  <vm-links-group [title]="data?.title" [links]="data?.items"></vm-links-group>
</section>
